import { Store } from "@tanstack/store"

export type Phase = "preparing" | "restoring" | "loading" | "ready"

export const bootStore = new Store<{ phase: Phase }>({ phase: "preparing" })

export function transition(phase: Phase): void {
	performance.mark(`boot:${phase}`)
	bootStore.setState(() => ({ phase }))
}
